/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiImagingConfig.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-imaging-config";

export class AutogenModelEdiImagingConfig<RowType extends ModelRow> extends Endpoint<RowType, RowEdiImagingConfigFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiImagingConfig extends ModelRow<RowEdiImagingConfigFields> {
	constructor(values?: Partial<RowEdiImagingConfigFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiImagingConfigFields {
	alt_img_comm: number;
	company_id: string;
	custom_filename: string;
	id: string;
	image_description: string;
	image_type: number;
	next_batch: number;
	parent_id: string;
	required: string;
	use_sequence: string;
}

